<!-- sub-nav-->
  <div class="eva-3-sub-nav">
  <div class="sub-nav-corners-container">
    <div class="sub-nav-container">
      <ul class="sub-nav-items-container" [ngClass]="{'-eva-3-bc-white': isMobile}">
        <li *ngFor="let tab of tabs; let index = index" class="sub-nav-item -subtitle" [ngClass]="{'-active': selectedIndex === index}" (click)="setActiveTab(index)">
          <label class="sub-nav-label">
              <span class="tab-text">{{tab.text}}</span>
          </label>
          <label class="sub-nav-label">
              <span>{{ 'tab-filter.from' | translate }} </span>
              <span>{{ getCurrencySymbol()}} {{ getMinimumPriceFormatted(tab.minimumPrice) }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</div>  